
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/items",
      function () {
        return require("private-next-pages/items.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/items"])
      });
    }
  